import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class LaiFormFactory {

  constructor(private fb: FormBuilder) {}

  criarFormularioBase(usuario) {
    return this.fb.group({
      id: [null],
      nomeUsuarioLogado: [{ value: usuario.nome || '', disabled: true }, Validators.required],
      emailUsuarioLogado: [{ value: usuario.email || '', disabled: true }, [Validators.required, Validators.email]],
      cpfUsuarioLogado: [{ value: usuario.cpfcnpj || '', disabled: true }, Validators.required],
      dataNascimentoUsuario: [{ value: usuario.dataNascimento || '', disabled: true }, Validators.required],
      prioridadePessoaIdosa: [usuario.prioridadePessoaIdosa === true],
      username: [usuario.username || ''],
      titularidade: ['TITULAR', Validators.required],
      representanteLegal: this.criarGrupoRepresentanteLegal(),
      tematicas: this.fb.array([], Validators.required),
      outrosAssunto: [''],
      descricaoDetalhada: ['', [Validators.required, Validators.maxLength(5000)]],
      formaRetorno: ['EMAIL', Validators.required],
      emailResposta: [usuario.email || '', [Validators.required, Validators.email]],
      endereco: this.criarGrupoEndereco(),
      anexos: new FormArray([]),
      anexosRepresentanteLegal: new FormArray([]),
      unidadeDestinoId: [100002839],
      unidadeDestinoSigla: ['OUVIDORIA']
    });
  }

  criarGrupoRepresentanteLegal() {
    return this.fb.group({
      tipoPessoa: ['FISICA'],
      nomeRazaoSocial: [''],
      cpfCnpj: [''],
      dataNascimento: [''],
      email: ['', Validators.email],
      telefone: ['']
    });
  }

  criarGrupoEndereco() {
    return this.fb.group({
      cep: [''],
      logradouro: [''],
      numero: [''],
      complemento: [''],
      bairro: [''],
      cidade: [''],
      uf: ['']
    });
  }
}
